import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Skeleton,
  SkeletonText,
  Stack,
} from '@chakra-ui/react';

export interface OrderTableSkeletonProps {
  rows?: number;
}

export default function OrderTableSkeleton({ rows = 5 }: OrderTableSkeletonProps) {
  const renderSkeletonRow = (key: number) => {
    return (
      <Tr key={key}>
        <Td>
          <Flex alignItems="center">
            <Skeleton width="50px" height="50px" mr={4} />
            <SkeletonText noOfLines={2} spacing="2" width="140px" />
          </Flex>
        </Td>
        <Td>
          <SkeletonText noOfLines={1} width="60px" />
        </Td>
        <Td>
          <SkeletonText noOfLines={1} width="60px" />
        </Td>
        <Td>
          <Stack spacing={2}>
            <SkeletonText noOfLines={1} width="80px" />
            <Flex gap={2}>
              <Skeleton height="16px" width="16px" borderRadius="full" />
              <Skeleton height="16px" width="16px" borderRadius="full" />
            </Flex>
          </Stack>
        </Td>
        <Td>
          <SkeletonText noOfLines={1} width="70px" />
        </Td>
        <Td>
          <SkeletonText noOfLines={1} width="50px" />
        </Td>
      </Tr>
    );
  };

  return (
    <Box overflowX="auto">
      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>Item</Th>
            <Th>Order Total</Th>
            <Th>Date</Th>
            <Th>Status</Th>
            <Th>Tracking</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {Array.from({ length: rows }).map((_, index) => renderSkeletonRow(index))}
        </Tbody>
      </Table>
    </Box>
  );
}
